import React, { useMemo } from 'react';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';

import { useTranslation } from 'hooks/useTranslation';

import { Paper } from 'features/app/components/Paper';
import { BalanceCurrency } from 'features/app/ts/BalanceCurrency';
import { UserBalanceItem } from 'features/finance/components/UserBalanceItem';
import { splitArrayIntoTwoHalves } from 'features/app/utils/splitArrayIntoTwoHalves';

import { useStyles } from './styles';

type Props = {
  partnerBalance?: BalanceCurrency[];
};

export const UserOtherBalances: React.FC<Props> = ({ partnerBalance }) => {
  const { t } = useTranslation('finance');
  const classes = useStyles();

  const dividedIntoTwoHalvesBalances = useMemo(
    () => (partnerBalance?.length ? splitArrayIntoTwoHalves(partnerBalance) : null),
    [partnerBalance]
  );

  return (
    <Paper className={classes.container}>
      <Typography variant="h6" className={classes.title}>
        {t('otherBalances')}
      </Typography>

      <Box display="flex" flexWrap="wrap" justifyContent="space-between" flex={1} className={classes.balancesWrapper}>
        {dividedIntoTwoHalvesBalances
          ? Object.keys(dividedIntoTwoHalvesBalances).map(halfColumn => (
              <Box display="flex" flexDirection="column" key={halfColumn}>
                {dividedIntoTwoHalvesBalances[halfColumn as unknown as keyof typeof dividedIntoTwoHalvesBalances]?.map(
                  balance => (
                    <UserBalanceItem balance={balance} key={balance?.id} />
                  )
                )}
              </Box>
            ))
          : null}
      </Box>
    </Paper>
  );
};